import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';
import { SharedService } from '@AppRoot/shared/services/shared.service';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss'],
})
export class TrackingComponent {
  awbnumber!: string;
  isLoading = false;
  trackingResults:any= '';
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private sharedService: SharedService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.awbnumber = params['tracking_id'];
    });
  }

  trackOrder() {
    this.isLoading = true;
    this.sharedService.getUserDeliveryInfo(this.awbnumber).subscribe({
      next: (res: APIResponse) => {
        if (res.success) {
          this.trackingResults = res.data;
          this.isLoading = false;
        } else {
          this.errorMessage = res.message;
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.errorMessage = 'Unable to fetch Order Details Right Now';
      },
    });
  }
}
